module.exports = __webpack_public_path__ + "static/vf_mtshirts_core.853444c8.svg";